<template>
  <q-card
    class="q-pa-md column"
    style="height: 70vh;width: 100vw;max-width: 400px"
  >
    <q-card-section class="col-grow column">
      <header class="q-mb-md">
        <span class="text-bold q-mb-md" style="font-size: 1.4rem">
          绑定用样本组
        </span>
      </header>
      <q-scroll-area class="column col-grow">
        <q-list>
          <q-item
            clickable
            :disable="bandGroup && bandGroup.id === group.id"
            dense
            style="height: 36px"
            class="q-mb-sm row items-center justify-between"
            v-for="group in sampleGroupList"
            :key="group.id"
            @click="checked = group.id"
            :class="{
              'bind-user-group-item-active': checked === group.id,
              'bind-user-group-item-disable':
                bandGroup && bandGroup.id === group.id,
            }"
          >
            <span>
              {{ group.name }}
              <span v-if="bandGroup && bandGroup.id === group.id">
                （当前已绑定）
              </span>
            </span>

            <q-badge v-if="group.user_group">
              {{ group.user_group.name }}
            </q-badge>
            <q-badge v-else color="green">
              未绑定用户组
            </q-badge>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-card-section>

    <q-card-actions class="row justify-end">
      <q-btn outline color="primary" @click="$emit('cancel')">取消</q-btn>
      <q-btn
        flat
        class="text-white bg-primary"
        :disable="!checked"
        @click="doBind"
      >
        确认
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { getSampleGroupList } from "@/api/endpoints/sample-group/getSampleGroupList";
import { bindUserGroupToSampleGroup } from "@/api/endpoints/sample-group/bindUserGroupToSampleGroup";
export default {
  props: {
    groupId: {
      type: String,
    },

    /**
     * 已绑定的目标分组对象
     */
    bandGroup: {
      type: Object,
    },
  },

  data() {
    return {
      sampleGroupList: [],
      checked: null,
    };
  },

  mounted() {
    this.fetchSampleGroupList();
  },

  methods: {
    /**
     * 获取用户分组列表
     */
    async fetchSampleGroupList() {
      try {
        const res = await getSampleGroupList();
        if (res.status || res.error) throw Error(res.detail || res.message);
        res.sort(
          (s1, s2) => parseFloat((s1 || {}).name) - parseFloat((s2 || {}).name)
        );
        this.sampleGroupList = res;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      }
    },

    async doBind() {
      // groupId: 当前用户组 的 id
      // checked: 选中的样本组的 ID
      const { groupId, checked } = this;
      try {
        const res = await bindUserGroupToSampleGroup(groupId, checked);
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.$q.notify({ type: "success", message: "已绑定" });
        this.$emit("updated");
      } catch (err) {
        this.$q.notify({ type: "danger", message: err.toString() });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.bind-user-group-item-active {
  background-color: rgba($primary, 0.1);
  color: $primary !important;
  font-weight: bold;
}
</style>
